// extracted by mini-css-extract-plugin
export default {"searchBarSection":"style_searchBarSection__WwOKt","icon":"style_icon__wafLK","searchBar":"style_searchBar__uyXmJ"};